import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

var contactMapCard = document.querySelector(".regen-room-map");
var mapLat = 52.40754
var mapLong = -1.88939

if(contactMapCard){

    setOptions({ 
        key: "AIzaSyBS5h4Lhu3A2L8HRD9GSJYqgUZm1QvJTgE"
    });

    // Get directions modal
    async function initMap() {

        const { Map } = await importLibrary("maps")
        const { AdvancedMarkerElement } = await importLibrary("marker")

        // Set up map
        const map = new Map(document.getElementById("map"), {
            center: { lat: mapLat, lng: mapLong },
            zoom: 11,
            mapId: "google.maps.MapTypeId.ROADMAP",
        })

        // Set up custom marker
        const parser = new DOMParser()
        const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48"><path fill="#000000" d="M24 0C14.059 0 6 8.059 6 18c0 10.125 7.615 19.349 16.5 28.525.549.563 1.451.563 2 0C34.385 37.349 42 28.125 42 18 42 8.059 33.941 0 24 0z"/><circle fill="#FFFFFF" cx="24" cy="18" r="8"/></svg>';
        const pinSvg = parser.parseFromString(
            pinSvgString,
            "image/svg+xml"
        ).documentElement
        const marker = new AdvancedMarkerElement({
            map,
            position: { lat: mapLat, lng: mapLong },
            content: pinSvg,
        })

        // Set up Street View
        const panorama = new google.maps.StreetViewPanorama(
            document.getElementById("pano"),
            {
                position: { lat: mapLat, lng: mapLong },
                pov: {
                    heading: 34,
                    pitch: 10,
                },
            }
        )

        //map.setStreetView(panorama)

        // Button to show/hide street view
        const streetViewSubmit = document.getElementById("streetViewSubmit")
        const streetViewLabel = streetViewSubmit.querySelector("span")
        const panoElement = document.getElementById("pano")

        streetViewSubmit.addEventListener("click", function () {

            const isActive = streetViewSubmit.classList.toggle("is-active")

            if (isActive) {
                // Activate Street View
                map.setStreetView(panorama)
                panoElement.style.display = "block"
                streetViewLabel.textContent = "Map View"
            } else {
                // Deactivate Street View
                map.setStreetView(null)
                panoElement.style.display = "none"
                streetViewLabel.textContent = "Street View"
            }
        })


        // Add directions
        const directionsService = new google.maps.DirectionsService()
        const directionsRenderer = new google.maps.DirectionsRenderer({
            draggable: true,
            map,
            panel: document.getElementById("panel"),
        })

        const onChangeHandler = function () {
            calculateAndDisplayRoute(directionsService, directionsRenderer)
        }

        const directionsSubmit = document.getElementById("directionsSubmit")
        const directionsClear = document.getElementById("directionsClear")

        directionsSubmit.addEventListener("click", onChangeHandler)

        directionsClear.addEventListener("click", function (e) {
            const directionsSource = document.getElementById("directionsSource")

            // Clear the input
            directionsSource.value = ""

            // Clear the panel
            document.getElementById("panel").innerHTML = ""

            // Reset the Map
            // Clear directions from the map
            directionsRenderer.setDirections({ routes: [] })

            // Optionally reset the map center and zoom if needed
            map.setCenter({ lat: mapLat, lng: mapLong })
            map.setZoom(11)


            // Hide clear button
            directionsClear.classList.add("d-none")
        })

        function calculateAndDisplayRoute(directionsService, directionsRenderer) {
            const start = document.getElementById("directionsSource").value

            directionsService
                .route({
                    origin: start,
                    destination: {
                        lat: mapLat,
                        lng: mapLong,
                    },
                    travelMode: google.maps.TravelMode.DRIVING,
                })
                .then(response => {
                    directionsRenderer.setDirections(response)
                })
                .catch(e => console.log("error loading these directions"))

            directionsClear.classList.remove("d-none")
        }
    }

    initMap() 

}




